<h2>{{ 'Gestione stampe' | translate }}</h2>

<ui-table
  [rowSelection]="'checkbox'"
  [fields]="fields"
  [pager]="pager$"
  [reload]="reload$"
  [filters]="filters$ | async"
  [itemsPage]="(page$ | async)?.current"
  [itemsPerPage]="(page$ | async)?.limit"
  [selected]="selectedItems?.length ? selectedItems : []"
  [contextMenuActions]="contextMenus"
  (itemsPageChange)="applyChangePageHandler($event)"
  (select)="selectHandler($event)"
  (rowAction)="manageRowActions($event)">
  <div tableActions>
    <app-entity-actions
      className="BeneS"
      [selectedItemsCount]="selectedItems?.length || 0"
      [config]="{ showExport: !!isExportEnable }"
      (export)="exportHandler()"
      (add)="addHandler()"
      (delete)="deleteSelectedHandler()"
      (collectionAdd)="addToCollectionHandler()">
    </app-entity-actions>
  </div>
  <div tableFilters>
    <ui-filters
      [dialogFilters]="MobileFiltersComponent"
      (action)="applyFilterWithDelayHandler($event)">
      <app-card-s-filters
        [filters]="filtersObj$ | async"
        #desktopFilter>
      </app-card-s-filters>
    </ui-filters>
  </div>
</ui-table>
